import React, { useEffect, useState } from "react";


import {
    RefundOptionsCategoriesObject,
    UserSubmitRequestDataInterface
} from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest";


import {
    Row, Col
} from "react-bootstrap";


import {
    ButtonComponent
} from "@Components/Forms";

import {
    CheckboxFieldComponent
} from "@Elements";


import IconArrowLeftSmBrown from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-arrow_left-sm-brown.svg";
import IconArrowRightSmBrown from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-arrow_right-sm-brown.svg";
import IconAttachFileSmBlack from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-attach_file-sm-black.svg";


import "./index.scss";
import {UseQyvoUser} from "@Store/@Hooks";
import {SvgIconComponent} from "@Components/Elements";


interface QyvoUserDataInterface {
    qyvo_user_first_name: string;
    qyvo_user_last_name: string;
    qyvo_user_email: string;
    qyvo_user_registration_date: string;
}

interface QyvoUserAddressDataInterface {
    qyvo_user_address_country?: number;
    qyvo_user_address_street?: string;
    qyvo_user_address_house_no?: string;
    qyvo_user_address_postal_code?: string;
    qyvo_user_address_city?: string;
    qyvo_user_address_phone_number?: string;
}


interface UserDashboardSubmitRequestStep3ComponentProps {
    userSubmitRequestStepSetter: (step: number) => void;
    userSubmitRequestData: UserSubmitRequestDataInterface;
    userSubmitRequestDataSetter: (userSubmitRequestData: UserSubmitRequestDataInterface) => void;
}


export const UserDashboardSubmitRequestStep3Component:React.FC<UserDashboardSubmitRequestStep3ComponentProps> = ({
    userSubmitRequestStepSetter,
    userSubmitRequestData, userSubmitRequestDataSetter
}) => {


    // const [QyvoUserData, setQyvoUserData] = useState<QyvoUserDataInterface | null>(null);
    // const [QyvoUserAddressData, setQyvoUserAddressData] = useState<QyvoUserAddressDataInterface | null>(null);
    //
    //
    // useEffect(() => {
    //
    //     if (QyvoUserData) {
    //         return;
    //     }
    //
    //     const getQyvoUserData = async () => {
    //         try {
    //             const response = await fetch(
    //                 `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/get-user-by-email/?user_email=${QyvoUser?.qyvoUserEmail}&user_data=true`
    //             );
    //             if (response.ok) {
    //                 const responseData = await response.json();
    //                 setQyvoUserData(responseData);
    //             }
    //         } catch (e) {
    //             console.error(e);
    //         }
    //     };
    //
    //     getQyvoUserData();
    //
    // }, []);
    //
    // useEffect(() => {
    //
    //     if (QyvoUserAddressData) {
    //         return;
    //     }
    //
    //     const getQyvoUserAddressData = async () => {
    //         try {
    //             const response = await fetch(
    //                 `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/get-qyvo-user-address-data/?qyvo_user_email=${QyvoUser?.qyvoUserEmail}`
    //             );
    //             if (response.ok) {
    //                 const responseData = await response.json();
    //                 setQyvoUserAddressData(responseData);
    //             }
    //         } catch (e) {
    //             console.log(e);
    //         }
    //     };
    //
    //     getQyvoUserAddressData();
    //
    // }, []);


    const {
        refundOptionsStep: storedRefundOptions,
        attachedDocumentsStep: {
            documentsList,
        },
        personalDataStep: {
            userFirstName: userFirstNameDefault, userLastName: userLastNameDefault,
            userAddressStreet: userAddressStreetDefault, userAddressHouseNo: userAddressHouseNoDefault,
            userAddressPostCode: userAddressPostCodeDefault, userAddressCityOrTown: userAddressCityOrTownDefault,
        },
    } = userSubmitRequestData;


    const [userFirstName, setUserFirstName] = useState(userFirstNameDefault);
    const [userLastName, setUserLastName] = useState(userLastNameDefault);

    const [userAddressStreet, setUserAddressStreet] = useState(userAddressStreetDefault);
    const [userAddressHouseNo, setUserAddressHouseNo] = useState(userAddressHouseNoDefault);
    const [userAddressPostCode, setUserAddressPostCode] = useState(userAddressPostCodeDefault);
    const [userAddressCityOrTown, setUserAddressCityOrTown] = useState(userAddressCityOrTownDefault);


    // if (!QyvoUserData || !QyvoUserAddressData) {
    //     return  null;
    // }


    const changeUserFirstName = (e: React.ChangeEvent<HTMLInputElement>) => {
        const userFirstName = e.target.value;
        setUserFirstName(userFirstName);
        userSubmitRequestData.personalDataStep.userFirstName = userFirstName;
        userSubmitRequestDataSetter({ ...userSubmitRequestData });
    };

    const changeUserLastName = (e: React.ChangeEvent<HTMLInputElement>) => {
        const userLastName = e.target.value;
        setUserLastName(userLastName);
        userSubmitRequestData.personalDataStep.userLastName = userLastName;
        userSubmitRequestDataSetter({ ...userSubmitRequestData });
    };

    const changeUserAddressStreet = (e: React.ChangeEvent<HTMLInputElement>) => {
        const userAddressStreet = e.target.value;
        setUserAddressStreet(userAddressStreet);
        userSubmitRequestData.personalDataStep.userAddressStreet = userAddressStreet;
        userSubmitRequestDataSetter({ ...userSubmitRequestData });
    };

    const changeUserAddressHouseNo = (e: React.ChangeEvent<HTMLInputElement>) => {
        const userAddressHouseNo = e.target.value;
        setUserAddressHouseNo(userAddressHouseNo);
        userSubmitRequestData.personalDataStep.userAddressHouseNo = userAddressHouseNo;
        userSubmitRequestDataSetter({ ...userSubmitRequestData });
    };

    const changeUserAddressPostCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        const userAddressPostCode = e.target.value;
        setUserAddressPostCode(userAddressPostCode);
        userSubmitRequestData.personalDataStep.userAddressPostCode = userAddressPostCode;
        userSubmitRequestDataSetter({ ...userSubmitRequestData });
    };

    const changeUserAddressCityOrTown = (e: React.ChangeEvent<HTMLInputElement>) => {
        const userAddressCityOrTown = e.target.value;
        setUserAddressCityOrTown(userAddressCityOrTown);
        userSubmitRequestData.personalDataStep.userAddressCityOrTown = userAddressCityOrTown;
        userSubmitRequestDataSetter({ ...userSubmitRequestData });
    };


    const checkedRefundOptions = new Set<number>(storedRefundOptions);

    const refundOptionsCategoriesList = RefundOptionsCategoriesObject.map((refundCategory) => {

        const {
            refundOptionsCategoryId,
            refundOptionsCategoryOptions,
        } = refundCategory;

        const refundOptionsList = Object.entries(refundOptionsCategoryOptions).map(([refundOptionId, refundOptionName]) => {
            if (!checkedRefundOptions.has(+refundOptionId)) {
                return null;
            }
            return (
                <CheckboxFieldComponent
                    key={refundOptionId}
                    checkboxLabel={refundOptionName}
                    checkboxCheckedStatus={true}
                    checkboxDisabledStatus={true}
                />
            );
        }).filter((refundOptionId) => !!refundOptionId);

        if (!refundOptionsList.length) {
            return null;
        }

        return (
            <Col key={refundOptionsCategoryId} xs={12} className={'user-dashboard-submit-request-step__step-section__section-form__form-sub-section'}>
                <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-sub-section__sub-section-content'}>
                    {refundOptionsList}
                </Row>
            </Col>
        );

    });


    const uploadedDocumentsList = documentsList.map((uploadedDocument, i) => {
        return (
            <Col key={`index-${i}`} xs={12} className={'user-uploaded-document'}>
                <SvgIconComponent iconSource={IconAttachFileSmBlack} />
                <span>{uploadedDocument.userDocumentName}</span>
            </Col>
        );
    });


    return (
        <Col xs={12} className={'user-dashboard-submit-request-step'}>
            <Row className={'user-dashboard-submit-request-step__step-content'}>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-header'}>
                    <span className={'user-dashboard-submit-request-step__step-header__main-header'}>Refund Summary & Personal Data</span>
                </Col>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-container'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Types of refund you choose in the step one</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>
                            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>
                                {refundOptionsCategoriesList}
                            </Row>
                        </Col>
                    </Row>
                </Col>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-container'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Uploaded documents</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>
                            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>
                                {uploadedDocumentsList}
                            </Row>
                        </Col>
                    </Row>
                </Col>

                {/*<Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>*/}
                {/*    <Row className={'user-dashboard-submit-request-step__step-section__section-content'}>*/}
                {/*        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>*/}
                {/*            <span>Please confirm that Your personal data and requested refund options are correct</span>*/}
                {/*        </Col>*/}
                {/*        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>*/}
                {/*            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>*/}
                {/*                <Col xs={12} className={'input-field-component'}>*/}
                {/*                    <Row className={'input-field-component__field-content'}>*/}
                {/*                        <Col xs={12} className={'input-field-component__field-input'}>*/}
                {/*                            <input*/}
                {/*                                type={'text'} placeholder={'Example Answer'}*/}
                {/*                                value={''} onChange={() => undefined}*/}
                {/*                            />*/}
                {/*                        </Col>*/}
                {/*                    </Row>*/}
                {/*                </Col>*/}
                {/*            </Row>*/}
                {/*        </Col>*/}
                {/*    </Row>*/}
                {/*</Col>*/}

                <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-container'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Personal Data</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>
                            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>
                                <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form__form-raw'}>
                                    <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-raw__raw-content'}>
                                        <Col xs={6} lg={4} className={'input-field-component'}>
                                            <Row className={'input-field-component__field-content'}>
                                                <Col xs={12} className={'input-field-component__field-label'}>
                                                    <span className={'input-field-component__field-label__label-text'}>First Name</span>
                                                    <span className={'input-field-component__field-label__label-required-status'}>*</span>
                                                </Col>
                                                <Col xs={12} className={'input-field-component__field-input'}>
                                                    <input
                                                        type={'text'}
                                                        value={userFirstName} onChange={changeUserFirstName}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={6} lg={4} className={'input-field-component'}>
                                            <Row className={'input-field-component__field-content'}>
                                                <Col xs={12} className={'input-field-component__field-label'}>
                                                    <span className={'input-field-component__field-label__label-text'}>Last Name</span>
                                                    <span className={'input-field-component__field-label__label-required-status'}>*</span>
                                                </Col>
                                                <Col xs={12} className={'input-field-component__field-input'}>
                                                    <input
                                                        type={'text'}
                                                        value={userLastName} onChange={changeUserLastName}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form__form-raw'}>
                                    <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-raw__raw-content'}>
                                        <Col xs={6} lg={4} className={'input-field-component'}>
                                            <Row className={'input-field-component__field-content'}>
                                                <Col xs={12} className={'input-field-component__field-label'}>
                                                    <span className={'input-field-component__field-label__label-text'}>Street</span>
                                                    <span className={'input-field-component__field-label__label-required-status'}>*</span>
                                                </Col>
                                                <Col xs={12} className={'input-field-component__field-input'}>
                                                    <input
                                                        type={'text'}
                                                        value={userAddressStreet} onChange={changeUserAddressStreet}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={6} lg={2} className={'input-field-component'}>
                                            <Row className={'input-field-component__field-content'}>
                                                <Col xs={12} className={'input-field-component__field-label'}>
                                                    <span className={'input-field-component__field-label__label-text'}>Number</span>
                                                    <span className={'input-field-component__field-label__label-required-status'}>*</span>
                                                </Col>
                                                <Col xs={12} className={'input-field-component__field-input'}>
                                                    <input
                                                        type={'text'}
                                                        value={userAddressHouseNo} onChange={changeUserAddressHouseNo}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={6} lg={2} className={'input-field-component'}>
                                            <Row className={'input-field-component__field-content'}>
                                                <Col xs={12} className={'input-field-component__field-label'}>
                                                    <span className={'input-field-component__field-label__label-text'}>Post code</span>
                                                    <span className={'input-field-component__field-label__label-required-status'}>*</span>
                                                </Col>
                                                <Col xs={12} className={'input-field-component__field-input'}>
                                                    <input
                                                        type={'text'}
                                                        value={userAddressPostCode} onChange={changeUserAddressPostCode}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={6} lg={4} className={'input-field-component'}>
                                            <Row className={'input-field-component__field-content'}>
                                                <Col xs={12} className={'input-field-component__field-label'}>
                                                    <span className={'input-field-component__field-label__label-text'}>City/Town</span>
                                                    <span className={'input-field-component__field-label__label-required-status'}>*</span>
                                                </Col>
                                                <Col xs={12} className={'input-field-component__field-input'}>
                                                    <input
                                                        type={'text'}
                                                        value={userAddressCityOrTown} onChange={changeUserAddressCityOrTown}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </Col>
                    </Row>
                </Col>

                <Col className={'user-dashboard-submit-request-step__step-buttons'}>
                    <Row className={'user-dashboard-submit-request-step__step-buttons__buttons-content'}>
                        <ButtonComponent
                            size={'l'} type={'flat'}
                            text={'Back'} iconLeft={IconArrowLeftSmBrown}
                            callback={() => userSubmitRequestStepSetter(2)}
                        />
                        <ButtonComponent
                            size={'l'}
                            text={'Next Step'} iconRight={IconArrowRightSmBrown}
                            callback={() => userSubmitRequestStepSetter(4)}
                        />
                    </Row>
                </Col>
            </Row>
        </Col>
    );

};


export default UserDashboardSubmitRequestStep3Component;
